export const useStyles = (theme) => ({
  paper: {
    padding: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  contentRoot: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down(960)]: {
      flexDirection: "column",
    },
  },
  detailStyle: {
    width: "100%",
    fontSize: 18,
    paddingLeft: 20,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(960)]: { paddingRight: 20 },
  },
  tooltip: {
    "&:hover": { cursor: "pointer" },
  },
});
